import { useQuery } from '@tanstack/react-query';
import { clientService } from '../services/clientService';

export const useClients = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['companyClients'],
        queryFn: () => clientService.getAllClients().then(res => res.data.data),
        staleTime: 1000 * 60 * 5,
    });

    const clients = (data || []).map(client => ({
        id: client.id,
        name: `${client.title ? client.title + ' ' : ''}${client.first_name} ${client.last_name}`.trim(),
        companyName: client.company_name || '—',
        email: client.email,
        phone: client.phone,
        address: [client.street_1, client.street_2].filter(Boolean).join(', ') || '—',
        city: client.city?.name || '—',
        state: client.state?.name || '',
        postalCode: client.postal_code || '',
        country: client.country || '—',
        fullAddress: [
            [client.street_1, client.street_2].filter(Boolean).join(', '),
            client.city?.name,
            client.state?.name,
            client.postal_code,
            client.country
        ].filter(Boolean).join(', ') || 'No address provided',
        tag: client.company_name ? 'Corporate' : 'Individual',
        status: client.user?.role === 'admin' ? 'Active' : 'Lead',
        lastActivity: 'Just now',
        averageRating: client.average_rating,
        raw: client,
    }));

    return {
        clients,
        isLoading,
        error,
        refetch,
    };
};